export function onReady(fn, hx = false) {
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1)
  } else {
    document.addEventListener("DOMContentLoaded", fn)
  }
  if (hx) {
    document.addEventListener("htmx:afterSettle", fn)
  }
}

export const qs = (s, el = document) => el.querySelector(s)
export const qsa = (s, el = document) =>
  Array.prototype.slice.call(el.querySelectorAll(s))

// onReady() for features whose code is only worth downloading when the page
// actually contains the markup they enhance. `load` is expected to dynamic
// import the component and call its init function.
export function onReadyIfPresent(selector, load, hx = false) {
  onReady(() => {
    if (qs(selector)) load()
  }, hx)
}
